import { render, staticRenderFns } from "./mobile-upload.vue?vue&type=template&id=12a83da9&"
import script from "./mobile-upload.vue?vue&type=script&lang=ts&"
export * from "./mobile-upload.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-upload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports